import api from './client'

// Maestro de cuentas contables (ABM)
export const cuentasContablesApi = {
  listar: (params = {}) => api.get('/cuentas-contables', { params }),
  crear: (data) => api.post('/cuentas-contables', data),
  actualizar: (id, data) => api.put(`/cuentas-contables/${id}`, data),
  eliminar: (id) => api.delete(`/cuentas-contables/${id}`),
}

// Caja: movimientos (pago/cobranza), minutas y favoritos por usuario
export const cajaApi = {
  movimientos: (tipo, fecha) => api.get('/caja/movimientos', { params: { tipo, ...(fecha ? { fecha } : {}) } }),
  registrar: (data) => api.post('/caja/movimientos', data),
  revertirMovimiento: (id) => api.post(`/caja/movimientos/${id}/revertir`),
  borrarMovimiento: (id) => api.delete(`/caja/movimientos/${id}`),

  minutas: (params = {}) => api.get('/caja/minutas', { params }),
  minuta: (id) => api.get(`/caja/minutas/${id}`),
  cerrarMinuta: (id) => api.post(`/caja/minutas/${id}/cerrar`),
  reenviarMinuta: (id) => api.post(`/caja/minutas/${id}/reenviar`),
  descargarMinuta: (id) => `/api/caja/minutas/${id}/descargar`,

  favoritos: (tipo) => api.get('/caja/favoritos', { params: { tipo } }),
  agregarFavorito: (cuenta_contable_id, tipo) => api.post('/caja/favoritos', { cuenta_contable_id, tipo }),
  quitarFavorito: (id) => api.delete(`/caja/favoritos/${id}`),
}
